(function () {
  if (!document.body.hasAttribute('pt-1-ab-test')) return;

  var STAR_FILLED_PATH =
    'M14.6431 7.17815L11.8306 9.60502L12.6875 13.2344C12.7347 13.4314 12.7226 13.638 12.6525 13.8281C12.5824 14.0182 12.4575 14.1833 12.2937 14.3025C12.1298 14.4217 11.9343 14.4896 11.7319 14.4977C11.5294 14.5059 11.3291 14.4538 11.1562 14.3481L7.99996 12.4056L4.84184 14.3481C4.66898 14.4532 4.4689 14.5048 4.2668 14.4963C4.06469 14.4879 3.8696 14.4199 3.70609 14.3008C3.54257 14.1817 3.41795 14.0169 3.3479 13.8272C3.27786 13.6374 3.26553 13.4312 3.31246 13.2344L4.17246 9.60502L1.35996 7.17815C1.20702 7.04597 1.09641 6.87166 1.04195 6.67699C0.987486 6.48232 0.99158 6.27592 1.05372 6.08356C1.11586 5.89121 1.23329 5.72142 1.39135 5.59541C1.54941 5.4694 1.7411 5.39274 1.94246 5.37502L5.62996 5.07752L7.05246 1.63502C7.12946 1.44741 7.2605 1.28693 7.42894 1.17398C7.59738 1.06104 7.7956 1.00073 7.9984 1.00073C8.2012 1.00073 8.39942 1.06104 8.56785 1.17398C8.73629 1.28693 8.86734 1.44741 8.94434 1.63502L10.3662 5.07752L14.0537 5.37502C14.2555 5.39209 14.4477 5.46831 14.6064 5.59415C14.765 5.71999 14.883 5.88984 14.9455 6.08243C15.008 6.27502 15.0123 6.48178 14.9579 6.6768C14.9034 6.87183 14.7926 7.04644 14.6393 7.17877L14.6431 7.17815Z';

  var STAR_OUTLINE_PATH =
    'M14.9483 6.07866C14.8858 5.88649 14.7678 5.71712 14.6092 5.59188C14.4506 5.46665 14.2585 5.39116 14.0571 5.37491L10.3696 5.07741L8.9458 1.63429C8.86881 1.44667 8.73776 1.28619 8.56932 1.17325C8.40089 1.06031 8.20267 1 7.99987 1C7.79707 1 7.59885 1.06031 7.43041 1.17325C7.26197 1.28619 7.13093 1.44667 7.05393 1.63429L5.63143 5.07679L1.94205 5.37491C1.74029 5.39198 1.54805 5.4682 1.38941 5.59404C1.23078 5.71988 1.11281 5.88973 1.05028 6.08232C0.987751 6.27491 0.983448 6.48167 1.03791 6.67669C1.09237 6.87172 1.20317 7.04633 1.35643 7.17866L4.16893 9.60554L3.31205 13.2343C3.26478 13.4313 3.27695 13.6379 3.34704 13.828C3.41713 14.0181 3.54199 14.1832 3.70584 14.3024C3.8697 14.4216 4.0652 14.4895 4.26765 14.4976C4.47011 14.5058 4.67042 14.4537 4.8433 14.348L7.99955 12.4055L11.1577 14.348C11.3305 14.4531 11.5306 14.5047 11.7327 14.4962C11.9348 14.4878 12.1299 14.4198 12.2934 14.3007C12.4569 14.1816 12.5816 14.0168 12.6516 13.8271C12.7217 13.6373 12.734 13.431 12.6871 13.2343L11.8271 9.60491L14.6396 7.17804C14.7941 7.04593 14.9059 6.87093 14.9608 6.67522C15.0158 6.47951 15.0114 6.27189 14.9483 6.07866ZM13.9896 6.42054L10.9458 9.04554C10.8764 9.10537 10.8248 9.18312 10.7965 9.27031C10.7683 9.3575 10.7646 9.45076 10.7858 9.53991L11.7158 13.4649C11.7182 13.4703 11.7185 13.4765 11.7165 13.482C11.7145 13.4876 11.7105 13.4922 11.7052 13.4949C11.6939 13.5037 11.6908 13.5018 11.6814 13.4949L8.26143 11.3918C8.18257 11.3437 8.09193 11.3184 7.99955 11.3187V1.99991C8.01455 1.99991 8.01643 2.00491 8.02143 2.01616L9.56205 5.74116C9.59722 5.82631 9.65523 5.90008 9.72967 5.95434C9.80412 6.00861 9.89211 6.04125 9.98393 6.04866L13.9783 6.37116C13.9883 6.37116 13.9939 6.37116 13.9996 6.38929C14.0052 6.40741 13.9996 6.41429 13.9896 6.42054Z';

  var REVIEWS_IMMUNE = [
    {
      name: 'Carmen L.',
      rating: 5,
      text: 'Meine Vierbeiner können es kaum abwarten, wenn ich die Herzen verteilen. Sie lieben sie.'
    },
    {
      name: 'Nils R.',
      rating: 4.5,
      text: 'Langfristig ist tatsächlich eine deutliche Verbesserung zu erkennen. Man muß dann allerdings auch dabei bleiben.'
    }
  ];

  var REVIEWS_BELLY = [
    {
      name: 'Julia M.',
      rating: 5,
      text: 'Mila hatte monatelang weichen Kot. Nach 2 Wochen Belly endlich konstant.'
    },
    {
      name: 'Thomas N.',
      rating: 4.5,
      text: 'Zig Futtersorten ausprobiert, nichts hat geholfen. Patsli Belly hat alles beruhigt.'
    }
  ];

  var REVIEWS_MOVE = [
    {
      name: 'Heike A.',
      rating: 5,
      text: 'Mein Kater springt mehr und das Sofa ist wieder sein bester Freund.'
    },
    {
      name: 'Thost G.',
      rating: 4.5,
      text: 'Krass!!! Lana springt wieder zu mir auf die Couch, dass hat sie Monate nicht mehr gemacht.'
    }
  ];

  var REVIEWS_PEE = [
    {
      name: 'Sabine S.',
      rating: 5,
      text: 'Mein Kater trinkt mehr und das Klo sieht endlich wieder normal aus.'
    },
    {
      name: 'Henrik F.',
      rating: 4.5,
      text: 'Endlich etwas, das meine wählerische Katze freiwillig frisst. Nach 3 Wochen klarer Unterschied.'
    }
  ];

  var REVIEWS_SMILE = [
    {
      name: 'Stephi S.',
      rating: 5,
      text: 'Die Zähne von Nala sehen viel besser aus! Was aber echt krass ist, dass der Mundgeruch endlich weg ist!'
    },
    {
      name: 'Andy P.',
      rating: 4.5,
      text: 'Freddi hat immer aus dem Maul gestunken, dass war schon echt grenzwertig. Wir füttern die Snacks noch nicht so lange, was ich aber merke, ist aber das Mundgeruch schon fast weg ist! SUPER.'
    }
  ];

  var REVIEWS_BY_VARIANT = {
    immune: REVIEWS_IMMUNE,
    belly: REVIEWS_BELLY,
    move: REVIEWS_MOVE,
    pee: REVIEWS_PEE,
    smile: REVIEWS_SMILE
  };

  var REVIEWS = REVIEWS_BY_VARIANT[window.PT1_AB_TEST_VARIANT] || REVIEWS_IMMUNE;

  function buildStars(rating) {
    var filledCount = Math.floor(rating);
    var html = '<div class="pt1-ab-reviews__stars" role="img" aria-label="' + rating + ' out of 5 stars">';
    for (var i = 1; i <= 5; i++) {
      var isFilled = i <= filledCount;
      html +=
        '<span class="pt1-ab-reviews__star' + (isFilled ? ' pt1-ab-reviews__star--filled' : '') + '">' +
        '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        (isFilled
          ? '<path d="' + STAR_FILLED_PATH + '" fill="currentColor"/>'
          : '<path d="' + STAR_OUTLINE_PATH + '" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"/>') +
        '</svg>' +
        '</span>';
    }
    html += '</div>';
    return html;
  }

  function buildBlock() {
    var wrapper = document.createElement('div');
    wrapper.className = 'pt1-ab-reviews';

    var cardsHtml = REVIEWS.map(function (review) {
      return (
        '<div class="pt1-ab-reviews__card">' +
        '<div class="pt1-ab-reviews__card-header">' +
        buildStars(review.rating) +
        '<span class="pt1-ab-reviews__name">' + review.name + '</span>' +
        '</div>' +
        '<p class="pt1-ab-reviews__text">' + review.text + '</p>' +
        '</div>'
      );
    }).join('');

    wrapper.innerHTML =
      '<p class="pt1-ab-reviews__heading">Was andere Katzenbesitzer sagen</p>' +
      '<div class="pt1-ab-reviews__list">' + cardsHtml + '</div>';

    return wrapper;
  }

  function inject() {
    var containers = document.querySelectorAll(
      '.product-form > form div:has(>gp-row>div>gp-product-button)'
    );
    if (!containers.length) return false;
    containers.forEach(function (container, index) {
      if (!container.querySelector('.pt1-ab-reviews') && index === 0) {
        container.appendChild(buildBlock());
      }
    });
    return true;
  }

  if (inject()) return;

  var observer = new MutationObserver(function () {
    if (inject()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
